import api from "@/lib/api";

// Backend i18n endpoints (Phase 13A). Packs + languages are public; preference is authed.
export const i18nApi = {
  languages: () => api.get("/v1/i18n/languages").then((r) => r.data.data),
  pack: (lang, namespace) => api.get(`/v1/i18n/pack/${lang}/${namespace}`).then((r) => r.data.data),
  getPreference: () => api.get("/v1/i18n/preference").then((r) => r.data.data),
  setPreference: (lang) => api.put("/v1/i18n/preference", { lang }).then((r) => r.data.data),
};

export const I18N_NAMESPACES = ["common", "auth", "nav"];
export const LANG_STORAGE_KEY = "ciq_lang";

// Map a BCP-47 browser locale (e.g. "hi-IN") to the closest enabled language code.
export function closestEnabled(browserLang, enabledCodes) {
  if (!browserLang) return null;
  const base = browserLang.toLowerCase().split("-")[0];
  return enabledCodes.includes(base) ? base : null;
}
